import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Layout from '../layout'
import config from '../../data/SiteConfig'
import Hero from '../components/NotFound/Hero'
import NotFound from '../components/NotFound'
import { graphql } from 'gatsby'
import HomeBlog from '../components/Home/home-blog'

class NotFoundPage extends Component {
  render() {
    const blogs = this.props.data.allMarkdownRemark.edges
    return (
      <Layout
        location={this.props.location}
        title="Contact Us"
        heroType="landing-half"
        hero={<Hero />}
      >
        <div className="not-found" style={{ marginBottom: '200px' }}>
          <div className="not-found-container">
            <Helmet>
              <title>{`Not Found | ${config.siteTitle}`}</title>
              <link rel="canonical" href={`${config.siteUrl}/contact/`} />
            </Helmet>
            <NotFound />
          </div>
        </div>
        <HomeBlog blogs={blogs} />
      </Layout>
    )
  }
}

export default NotFoundPage

export const pageQuery = graphql`
  query NotFoundQuery {
    allMarkdownRemark(
      filter: {fields: {slug: {regex: "/blog|video/"}}}
      limit: 3
      sort: {fields: {date: DESC}}
    ) {
      edges {
        node {
          fields {
            slug
            date
          }
          excerpt
          timeToRead
          frontmatter {
            title
            author {
              full_name
            }
            tags
            date
            layout
            length
            category
            assets {
              hero
            }
            nutgraf
            date
          }
        }
      }
    }
  }
`
